import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { ColumnsTable } from '../columns-table';
import { PADDING_SCHEMA } from '../padding';
export const SocialPropsSchema = z.object({
    style: z
        .object({
        color: COLOR_SCHEMA,
        backgroundColor: COLOR_SCHEMA,
        textAlign: z.enum(['left', 'right', 'center']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        facebookUrl: z.string().optional().nullable(),
        instagramUrl: z.string().optional().nullable(),
        youtubeUrl: z.string().optional().nullable(),
        tiktokUrl: z.string().optional().nullable(),
        linkedinUrl: z.string().optional().nullable(),
        xUrl: z.string().optional().nullable(),
        iconGap: z.number().min(0).optional().nullable(),
        iconSize: z.number().min(16).optional().nullable(),
        tableWidth: z.number().min(0).max(100).optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function Social({ style, props }) {
    const socials = [];
    if (props === null || props === void 0 ? void 0 : props.facebookUrl) {
        socials.push({ label: 'Follow us on FaceBook', url: props === null || props === void 0 ? void 0 : props.facebookUrl, icon: `${window.MyAppGlobals.siteURL}/resources/emails/facebook_icon.png`, });
    }
    if (props === null || props === void 0 ? void 0 : props.instagramUrl) {
        socials.push({ label: 'Follow us on Instagram', url: props === null || props === void 0 ? void 0 : props.instagramUrl, icon: `${window.MyAppGlobals.siteURL}/resources/emails/instagram_icon.png`, });
    }
    if (props === null || props === void 0 ? void 0 : props.youtubeUrl) {
        socials.push({ label: 'Like & Subscribe on YouTube', url: props === null || props === void 0 ? void 0 : props.youtubeUrl, icon: `${window.MyAppGlobals.siteURL}/resources/emails/youtube_icon.png`, });
    }
    if (props === null || props === void 0 ? void 0 : props.tiktokUrl) {
        socials.push({ label: 'Like & Follow on TikTok', url: props === null || props === void 0 ? void 0 : props.tiktokUrl, icon: `${window.MyAppGlobals.siteURL}/resources/emails/tiktok_icon.png`, });
    }
    if (props === null || props === void 0 ? void 0 : props.linkedinUrl) {
        socials.push({ label: 'Follow us on LinkedIn', url: props === null || props === void 0 ? void 0 : props.linkedinUrl, icon: `${window.MyAppGlobals.siteURL}/resources/emails/linkedin_icon.png`, });
    }
    if (props === null || props === void 0 ? void 0 : props.xUrl) {
        socials.push({ label: 'Follow us on X', url: props === null || props === void 0 ? void 0 : props.xUrl, icon: `${window.MyAppGlobals.siteURL}/resources/emails/x_icon.png`, });
    }
    const columns = socials.map((social, index) => (React.createElement("a", { key: index, href: social.url, style: { textDecoration: 'none' }, title: social.label, target: "_blank", rel: "noopener noreferrer" },
        React.createElement("img", { alt: social.label, src: social.icon, width: props === null || props === void 0 ? void 0 : props.iconSize, height: props === null || props === void 0 ? void 0 : props.iconSize, style: {
                width: props === null || props === void 0 ? void 0 : props.iconSize,
                height: props === null || props === void 0 ? void 0 : props.iconSize,
                outline: 'none',
                border: 'none',
                textDecoration: 'none',
                verticalAlign: 'middle',
                display: 'inline-block',
                maxWidth: '100%',
                marginRight: 8, // Add spacing between icons
            } }))));
    const socialProps = {
        fixedWidths: null,
        columnsCount: columns.length,
        columnsGap: props === null || props === void 0 ? void 0 : props.iconGap,
        contentAlignment: 'middle',
        tableWidth: props === null || props === void 0 ? void 0 : props.tableWidth,
    };
    return React.createElement(ColumnsTable, { props: socialProps, columns: columns, style: style });
    //return <div style={{ display: 'flex', gap: '8px' }}>{socialLinks}</div>;
}
//# sourceMappingURL=Social.js.map